<template>
  <p class="a-input a-input--disabled">
    {{$t('form.notifications.accreditation-request', { person, company })}}
  </p>
</template>

<script>
  export default {
    props: {
      data: Object,
      required: true
    },

    computed: {
      person() {
        return this.data.fio;
      },

      company() {
        return this.data.organization;
      },
    },

    methods: {
      async onClick() {
        this.$router.push({
          name: 'admin-accreditations-account',
          params: {
            userId: this.data.user,
            tab: 'accreditation'
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
